import { graphql } from '@/generated/gql';

export const CONTRACT_DEMAND_FILE_ATTACHMENTS_QUERY = graphql(/* GraphQL */ `
  query ContractDemandFileAttachments($parents: [TsrctAttachmentParentInput!]!, $filter: TsrctAttachmentFilterInput) {
    tesseract {
      attachments(parents: $parents, filter: $filter) {
        ...FileAttachment
      }
    }
  }
`);

export const CONTRACT_DEMAND_FILE_ATTACHMENTS_DEMAND_QUERY = graphql(/* GraphQL */ `
  query ContractDemandFileAttachmentsDemand($demandId: UUID!) {
    tesseract {
      contractDemand(id: $demandId) {
        id
        status
        sourcingCases {
          id
          status
        }
      }
    }
  }
`);
